//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponItem from './component/coupon-item'
export default {
    components: {couponItem},
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: ''
            })
        }
    },
    data () {
        return {
            form: {
                couponname: '',
                isused: '0',
                couponprice: 0,
                minimum: 0,
                amount: 0,
                surplus: 0,
                time: '',
                starttime: '',
                endtime: '',
                detail: ''
            }
        }
    },
    methods: {
        submitHandler() {
            this.cancleHandler();
        },
        cancleHandler() {
            this.$emit('close');
        },
        timeChange(e) {
            this.form.starttime = e ? e[0] : '';
            this.form.endtime = e ? e[1] : '';
        },
        afterDetail(data) {
            data.time = [data.starttime, data.endtime];
        }
    },
    mounted: function() {

    }
}
